var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.222,
    height: 18.179,
    viewBox: "0 0 18.222 18.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.111.333A8.779,8.779,0,0,1,15.555,3a8.755,8.755,0,0,1,2.667,6.422,8.755,8.755,0,0,1-2.667,6.422,8.779,8.779,0,0,1-6.444,2.667,8.779,8.779,0,0,1-6.444-2.667A8.755,8.755,0,0,1,0,9.423,8.755,8.755,0,0,1,2.667,3,8.779,8.779,0,0,1,9.111.333ZM15.405,5.8a6.908,6.908,0,0,0-3.926-3.243A13.439,13.439,0,0,1,12.717,5.8ZM9.09,2.168A12.117,12.117,0,0,0,7.383,5.8h3.457A12.962,12.962,0,0,0,9.09,2.168Zm-7.041,9.09H5.121a15.726,15.726,0,0,1-.128-1.835,15.726,15.726,0,0,1,.128-1.835H2.048a8.665,8.665,0,0,0-.213,1.835A8.665,8.665,0,0,0,2.048,11.258Zm.768,1.792a6.908,6.908,0,0,0,3.926,3.243A13.439,13.439,0,0,1,5.5,13.05ZM5.5,5.8A13.439,13.439,0,0,1,6.743,2.552,6.908,6.908,0,0,0,2.817,5.8ZM9.09,16.678a12.962,12.962,0,0,0,1.75-3.627H7.383A12.117,12.117,0,0,0,9.09,16.678Zm2.134-5.42a11.866,11.866,0,0,0,.171-1.835,11.866,11.866,0,0,0-.171-1.835H6.956a15.726,15.726,0,0,0-.128,1.835,15.726,15.726,0,0,0,.128,1.835Zm.256,5.036a6.908,6.908,0,0,0,3.926-3.243H12.717A13.439,13.439,0,0,1,11.479,16.294Zm1.579-5.036h3.073a7.292,7.292,0,0,0,.256-1.835,7.292,7.292,0,0,0-.256-1.835H13.058a15.726,15.726,0,0,1,.128,1.835A15.726,15.726,0,0,1,13.058,11.258Z",
    transform: "translate(0 0)",
    fill: "#868686"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeMobile);
export default __webpack_public_path__ + "static/media/globe-mobile.19dd90f359ce3d0869c909f4a2a7199a.svg";
export { ForwardRef as ReactComponent };